/*
 * Copyright (c) 2023-2024 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import { Modal, ModalProps } from 'antd'

export const ModalDialog = (props: ModalProps) => {
  return <Modal {...props} centered />
}
